var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleDoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-10 0 1034 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M981 303q9 0 15.5 6t6.5 15v376q0 9 -6.5 15t-15.5 6t-15 -6t-6 -15v-354q-42 2 -83 13q-40 10 -77.5 27t-71.5 39q-33 22 -63 48q-62 55 -97 116.5t-35 110.5q0 9 -6 15t-15 6t-15 -6t-6 -15q0 -51 -13 -92t-35 -74.5t-53 -60.5q-30 -26 -65 -46q-63 -37 -134 -55.5 t-127 -23.5v352q0 9 -6 15t-15 6t-15.5 -6t-6.5 -15v-376q0 -4 2 -8t5 -7t7.5 -4.5t8.5 -1.5q30 2 67 8q37 5 76.5 15.5t80.5 25.5q41 16 79 38q57 33 103 83t68 120q19 -40 49.5 -79t69.5 -73q33 -29 73 -55q39 -25 82.5 -43.5t91.5 -28.5q47 -11 97 -11v0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleDoor);
export default __webpack_public_path__ + "static/media/double-door.31a54fe32a7f2cbeef9c3c6126e7aa1c.svg";
export { ForwardRef as ReactComponent };